var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCirclePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.375 26.6664C46.375 37.643 37.4767 46.5413 26.5 46.5413C15.5233 46.5413 6.625 37.643 6.625 26.6664C6.625 15.6897 15.5233 6.79135 26.5 6.79135C37.4767 6.79135 46.375 15.6897 46.375 26.6664Z",
    stroke: "url(#paint0_linear_1356_11181)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1284 25.1964C33.8656 25.6879 34.2343 25.9336 34.3627 26.2434C34.475 26.5142 34.475 26.8185 34.3627 27.0893C34.2343 27.3991 33.8656 27.6448 33.1284 28.1363L24.83 33.6686C23.9377 34.2634 23.4916 34.5608 23.1217 34.5387C22.7994 34.5195 22.5017 34.3602 22.3069 34.1027C22.0833 33.8071 22.0833 33.271 22.0833 32.1986V21.1341C22.0833 20.0617 22.0833 19.5256 22.3069 19.23C22.5017 18.9725 22.7994 18.8132 23.1217 18.794C23.4916 18.7719 23.9377 19.0693 24.83 19.6641L33.1284 25.1964Z",
    stroke: "url(#paint1_linear_1356_11181)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1356_11181",
    x1: 6.625,
    y1: 46.5414,
    x2: 46.375,
    y2: 46.5414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21639E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1356_11181",
    x1: 6.625,
    y1: 46.5414,
    x2: 46.375,
    y2: 46.5414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21639E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6C3490"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclePlay);
export default __webpack_public_path__ + "static/media/circle-play.3444f21ed9785c44b56316753893da4f.svg";
export { ForwardRef as ReactComponent };